module.exports = __webpack_public_path__ + "static/media/swan-heron-dnd.cf187815.png";